// redux/notesSlice.js
import { createSlice } from '@reduxjs/toolkit';

const notesSlice = createSlice({
  name: 'notes',
  initialState: [], 
  reducers: {
    // Add a new textbox with a label (initial value will be empty string)
    addTextbox: (state, action) => {
      const label = action.payload.label || ''; // If label is passed, use it; otherwise, default to an empty string
      state.push({
        value: '',  // Initial value of the textbox
        label: label,  // The label for the textbox
      });
    },

    // Update the value of a specific textbox by index
    updateTextbox: (state, action) => {
      const { index, value } = action.payload;
      state[index].value = value;  // Update the value of the textbox at the given index
    },
  },
});

export const { addTextbox, updateTextbox } = notesSlice.actions;
export default notesSlice.reducer;
